import styled from "styled-components"

export const EnergyConsumptionContainer = styled.section<{
  isProposalSaving?: boolean
}>`
  *,
  & {
    opacity: ${({ isProposalSaving }) => (isProposalSaving ? 0.9 : 1)};
    pointer-events: ${({ isProposalSaving }) =>
      isProposalSaving ? `none` : `auto`};
  }
`
